<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-31 10:25:51
 * @FilePath: \frontend\src\layout\components\AppMain.vue
-->
<template>
  <section class="app-main">
    <div v-loading.fullscreen.lock="!isInit">
      <router-view v-slot="{ Component }">
        <transition name="fade-transform" mode="out-in">
          <component :is="Component" v-if="isInit" :key="key" />
        </transition>
      </router-view>
    </div>
  </section>
</template>

<script>
import {
  // errorMsg,
  warningMsg,
  // successMsg
} from '@/utils/message';
// import { devStatus } from '@/utils/const'
import { getTopic, reconfigurePubSub, subscribeTopic, unsubscribeTopic } from '@/utils/mqtt';
import { Hub } from 'aws-amplify/utils';
import { CONNECTION_STATE_CHANGE, ConnectionState } from '@aws-amplify/pubsub';
import { mapGetters } from 'vuex';
import { topicType } from '@/utils/const';
import { amplifySignOut } from '@/utils/auth';

export default {
  name: 'AppMain',
  inject: ['reload'],
  data() {
    return {
      hubListener: null,
      routechanging: false,
      subscriptions: [],
    };
  },
  computed: {
    ...mapGetters(['pubsubDisconnected', 'pubsubReloading', 'user_name', 'tenantId']),
    key() {
      return this.$route.path;
    },
    token: {
      get() {
        return this.$store.state.user.token;
      },
      set(value) {
        this.$store.dispatch('user/setToken', value);
      },
    },
    isInit: {
      get() {
        return this.$store.state.system.isInit;
      },
      set(value) {
        this.$store.dispatch('system/setIsInit', value);
      },
    },
  },
  watch: {
    token: {
      immediate: true,
      handler(val) {
        if (this.token) {
          this.isInit = true;
        }
      },
    },
    $route() {
      this.routechanging = true;
      // Hub detect disconnect detect with a delay
      setTimeout(() => {
        this.routechanging = false;
      }, 500);
    },
  },
  async created() {
    await reconfigurePubSub();
    this.hubListener = Hub.listen('pubsub', this.pubsubHubAction);
    this.subscribeUserTopic();

    // this.sockets.listener.subscribe(socketMsg.Socket_Dev_OffLine, (data) => {
    //   this.notify({
    //     title: 'Warning',
    //     message: data.name + ' ' + warningMsg.Offline,
    //     type: 'warning',
    //     duration: 2000
    //   })
    // })
    // this.sockets.listener.subscribe(socketMsg.Socket_Dev_Status, (data) => {
    //   if (data.status === devStatus.offline) {
    //     this.notify({
    //       title: 'Warning',
    //       message: data.name + ' ' + warningMsg.Offline,
    //       type: 'warning',
    //       duration: 2000
    //     })
    //   } else if (data.status === devStatus.normal) {
    //     this.notify({
    //       title: 'Success',
    //       message: data.name + ' ' + successMsg.Online,
    //       type: 'success',
    //       duration: 2000
    //     })
    //   }
    // })

    /*
    this.sockets.listener.subscribe(socketMsg.Socket_Alert_Trigger, data => {
      let msg = '';
      for (const cond of data) {
        msg += cond.cond_name + ' ' + successMsg.Triggered + '\n';
      }
      msg = msg.substring(0, msg.length - 1);
      this.notify({
        title: 'Success',
        message: msg,
        type: 'success',
        duration: 2000,
      });
    });
    */

    /*
    this.sockets.listener.subscribe(socketMsg.Socket_Exclusive, () => {
      this.message({
        message: errorMsg.W_is_exclusive,
        type: 'warning',
        duration: 5 * 1000,
      });
      this.$store.dispatch('user/resetUser');
      this.$socket.destroy();
      destroySocket();
      this.$router.push(`/login`);
    });
    */
  },
  beforeUnmount() {
    this.hubListener();
    unsubscribeTopic({ sub: this.subscriptions });
    /*
    this.sockets.listener.unsubscribe(socketMsg.Socket_Alert_Trigger);
    this.sockets.listener.unsubscribe(socketMsg.Socket_Role_Change);
    this.sockets.listener.unsubscribe(socketMsg.Socket_Exclusive);
    */
  },
  methods: {
    async pubsubHubAction(data) {
      const { payload } = data;
      if (payload.event === CONNECTION_STATE_CHANGE) {
        const connectionState = payload.data.connectionState;
        console.log('ConnectState:', connectionState);
        // Skip disconnect detection, if it is intentional (Route Change, Reload)
        //  there is no subscription, connection change to disconnected (Amplify PubSub Client)
        //  if there are upper component level subsucriptions, doesn't need skip (doesn't disconnect)
        if (connectionState === ConnectionState.Disconnected && !this.pubsubReloading && !this.routechanging) {
          console.log('Unintended Disconnect Detected');
          this.$store.dispatch('app/setPubSubDisconnected', true);
          this.message({
            message: warningMsg.MQTT_Disconnected,
            type: 'warning',
            duration: 5 * 1000,
          });
        }
      }
    },
    async subscribeUserTopic() {
      let messageHandler = null;
      let mqttTopic = '';
      let mqttData = null;
      let data = null;

      unsubscribeTopic({ sub: this.subscriptions });
      this.subscriptions = [];

      messageHandler = (target, data) => {
        this.userDeleteAction(target, data);
      };
      mqttTopic = getTopic(topicType.userDeleted, {
        tenant: this.tenantId,
        target: this.tenantId,
      });
      mqttData = {
        target: this.tenantId,
        messageHandler: messageHandler,
      };
      data = await subscribeTopic(mqttTopic, mqttData);
      if (data.status === 0) {
        this.subscriptions.push(data.data);
      }

      messageHandler = (target, data) => {
        this.adminChangeAction(target, data);
      };
      mqttTopic = getTopic(topicType.adminChanged, {
        tenant: this.tenantId,
        target: this.tenantId,
      });
      mqttData = {
        target: this.tenantId,
        messageHandler: messageHandler,
      };
      data = await subscribeTopic(mqttTopic, mqttData);
      if (data.status === 0) {
        this.subscriptions.push(data.data);
      }
    },
    async userDeleteAction(target, data) {
      if (this.user_name === data.userName) {
        this.message({
          message: warningMsg.User_Deleted,
          type: 'warning',
          duration: 5 * 1000,
        });
        await this.$store.dispatch('user/logout');
        this.$router.push(`/login`);
      }
    },
    async adminChangeAction(target, data) {
      if (this.user_name === data.userName) {
        this.message({
          message: warningMsg.Admin_role_changed,
          type: 'warning',
          duration: 5 * 1000,
        });
        await amplifySignOut();
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  top: 35px;
  min-height: calc(100vh - 35px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 20px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
